// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1uJPL","title":"BackImages_title__2qh6J","images":"BackImages_images__t2huE"};